module.exports = __webpack_public_path__ + "static/media/hamburger.615dea14.svg";